<section class="container-fluid">
  <div class="row">
    <div class="col-12">
      <div class="pdf-container">
        <pdf-viewer
          [src]="pdfSrc"
          [render-text]="true"
          [original-size]="true"
          [fit-to-page]="true"
          [autoresize]="true"
        ></pdf-viewer>
      </div>
    </div>
  </div>
</section>
